
import ViewResultCardComponent from '@/views/Hiv/ViewResultCard/ViewResultCardComponent';
export default ViewResultCardComponent;
